import React from "react";
import { isObject } from "lodash";
import { format } from "date-fns";
import {
    RuleConditionDate,
    TransactionRuleCondition,
} from "../../../common/types/transactionRule";

interface Props {
    condition: TransactionRuleCondition;
}

export const RuleDateCondition: React.FC<Props> = ({ condition }) => {
    if (!isObject(condition.value)) {
        return null;
    }

    const value = condition.value as RuleConditionDate;

    if (value.after && value.before) {
        return (
            <DisplayDateRange
                startDate={new Date(value.after)}
                endDate={new Date(value.before)}
            />
        );
    }

    if (value.after) {
        return <DisplayStartDate date={new Date(value.after)} />;
    }

    if (value.before) {
        return <DisplayEndDate date={new Date(value.before)} />;
    }

    return null;
};

interface DisplayDateRangeProps {
    startDate: Date;
    endDate: Date;
}

const DisplayDateRange: React.FC<DisplayDateRangeProps> = ({
    startDate,
    endDate,
}) => (
    <>
        Date between <strong>{format(startDate, "MMM d, yyyy")}</strong> and{" "}
        <strong>{format(endDate, "MMM d, yyyy")}</strong>
    </>
);

interface DisplaySingleDateProps {
    date: Date;
}

const DisplayStartDate: React.FC<DisplaySingleDateProps> = ({ date }) => (
    <>
        Date after <strong>{format(date, "MMM d, yyyy")}</strong>
    </>
);

const DisplayEndDate: React.FC<DisplaySingleDateProps> = ({ date }) => (
    <>
        Date before <strong>{format(date, "MMM d, yyyy")}</strong>
    </>
);
